import Video from '../util/video';

class VideoHeader {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    new Video(this.el);
  }
}

export default VideoHeader;
